import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal, Textarea, TextInput, Tabs } from "flowbite-react"
import Select from 'react-tailwindcss-select';
import { HiOutlineTrash, HiOutlineDocumentAdd, HiOutlineCube } from "react-icons/hi";
import { orderDetail } from '../redux/menuReducer';
import { openSnackBar } from '../redux/snackBarReducer';
import UploadImage from './Global/UploadImage';
// import { createProductSearchText } from '../../utils'
import swal from 'sweetalert2';
import styled from 'styled-components';
import { useTranslation } from "react-i18next";

export const SelectGrapeStyle = styled.div`
p.truncate{
    width: 65px;
}
div.relative.w-full{
	width: 142px;
}	
.flex.text-sm.text-gray-500.border.border-gray-300.rounded.shadow-sm.transition.duration-300{
	height: 42px
}
`
export const SelectCustomStyle = styled.div`
.flex.text-sm.text-gray-500.border.border-gray-300.rounded.shadow-sm.transition.duration-300{
	height: 42px
}
`

function OrderDetail(props) {
    const { t } = useTranslation();
    const { globalState, locationState, menuState, authState } = useSelector((state) => state);
    const { countries, menu_formats, page_formats, finishs } = locationState;
    const { currentWineMenu } = menuState;
    const nowDate = new Date();

    const dispatch = useDispatch();

    useEffect(() => {
    }, [])

    /////////select/////////////////
    const amounts = [1,5,10,15,20,25,30,35,40,45,50,60,70,80,90,100,125,150,175,200,225,250,275,300,350,400,450,500];
    const amount_options = [];
    const country_options = [];
    const menu_format_options = [];
    const finish_options = [];

    // amount
    if (amounts?.length > 0) {
        amounts.map((data, index) => {
            amount_options[index] = { value: data, label: data + " Stück" }
        })
    }

    // country
    if (countries?.length > 0) {
        countries.map((data, index) => {
            country_options[index] = { value: data._id, label: data.name[`${globalState.language}`] }
        })
    }

    // menu format
    if (menu_formats?.length > 0) {
        menu_formats.map((data, index) => {
            menu_format_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }

    // finish
    if (finishs?.length > 0) {
        finishs.map((data, index) => {
            finish_options[index] = { value: data._id, label: data[`${globalState.language}`] }
        })
    }

    const [modalShow, setModalShow] = useState(false);
    const [logoImage, setLogoImage] = useState(null);
    const [showLogoImage, setShowLogoImage] = useState(null);
    const [currentLengthOfFooter, setCurrentLengthOfFooter] = useState(0);
    const [useMyInfo, setUseMyInfo] = useState(false);
    const [pageDisable, setPageDisable] = useState(true);
    const [finishDisable, setFinishDisable] = useState(true);
    const [page_format_options, setPageFormatOption] = useState([]);

    const [orderData, setOrderData] = useState({
        project_name: "",
        amount: "",
        first_name: "",
        last_name: "",
        street_name: "",
        postal_code: "",
        city: "",
        country: "",
        menu_format: "",
        paper_size: "",
        finish: "",
        cover_title: "",
        footer_text: "",
        order_details: ""
    });

    function validate() {
        const {project_name, amount, first_name, last_name, street_name, postal_code, city, country,
            menu_format, paper_size, finish} = orderData

        if (!project_name) {
            dispatch(openSnackBar({ status: "warning", message: "please fill the project name" }))
            return false;
        } else if (!amount) {
            dispatch(openSnackBar({ status: "warning", message: "please select the amount" }))
            return false;
        } else if (!menu_format) {
            dispatch(openSnackBar({ status: "warning", message: "please select menu format" }))
            return false;
        } else if (!paper_size) {
            dispatch(openSnackBar({ status: "warning", message: "please select paper size" }))
            return false;
        } else if (!finishDisable && !finish) {
            dispatch(openSnackBar({ status: "warning", message: "please select finish" }))
            return false;
        } else if (!useMyInfo) {
            if (!first_name) {
                dispatch(openSnackBar({ status: "warning", message: "please fill the first name" }))
                return false;
            } else if (!last_name) {
                dispatch(openSnackBar({ status: "warning", message: "please fill the the last name" }))
                return false;
            } else if (!street_name) {
                dispatch(openSnackBar({ status: "warning", message: "please fill the street name" }))
                return false;
            } else if (!postal_code) {
                dispatch(openSnackBar({ status: "warning", message: "please fill the postal code" }))
                return false;
            } else if (!city) {
                dispatch(openSnackBar({ status: "warning", message: "please fill the city" }))
                return false;
            }else if (!country) {
                dispatch(openSnackBar({ status: "warning", message: "please select the country" }))
                return false;
            }
        }
        return true;
    }

    const createProduct = async () => {
        var validate_result = validate();

        if (validate_result) {
            const { project_name, amount, first_name, last_name, street_name, postal_code, city, country,
                menu_format, paper_size, finish, cover_title, footer_text, order_details } = orderData

            const formData = new FormData();
            
            formData.append("menu_id", currentWineMenu._id);
            formData.append("wine_menu", project_name);
            formData.append("amount", amount.value);
            formData.append("menu_format", menu_format.value);
            formData.append("page_format", paper_size.value);
            !finishDisable && formData.append("finish", finish.value);
            formData.append("cover_title", cover_title);
            formData.append("footer_text", footer_text);
            formData.append("order_detail", order_details);
            
            if(useMyInfo){
                const { userInfo } = authState;
                formData.append("user_id", userInfo.id);

            }else{
                formData.append("first_name", first_name);
                formData.append("last_name", last_name);
                formData.append("street_name", street_name);
                formData.append("postal_code", postal_code);
                formData.append("city", city);
                formData.append("country", country.value);
            }

            logoImage && formData.append("bottleImage", logoImage);
            
            const res = await dispatch(orderDetail(formData))
            if (res !== false) {
                dispatch(openSnackBar({ message: "Success Order Detail", status: 'success' }));
                close();
            } else {
                dispatch(openSnackBar({ message: "Failed Order Detail", status: 'error' }));
            }
        }

    }

    const selectMenuFormat = (value) => {
        setPageDisable(false);
        handleInputChange("menu_format", value);

        if(value.value == 2 || value.value == 3){
            setFinishDisable(false)
        }else{
            setFinishDisable(true)
        }
        
        let tmp_page_format_options = []

        menu_formats[value.value].page_format.map((data, index)=>{
            tmp_page_format_options[index] = {value: data, label: page_formats[data][`${globalState.language}`]}
        })

        setPageFormatOption([...tmp_page_format_options])
    }

    const handleInputChange = (key, value) => {
        orderData[`${key}`] = value;
        setOrderData({ ...orderData });
    };

    const openModal = async () => {
        const {name} = currentWineMenu;

        setOrderData({
            project_name: name ? name : "",
            amount: "",
            first_name: "",
            last_name: "",
            street_name: "",
            postal_code: "",
            city: "",
            country: "",
            menu_format: "",
            paper_size: "",
            finish: "",
            cover_title: "",
            footer_text: "",
            order_details: ""
        })
        setModalShow(true);
    }

    const closeModal = () => {
        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_leave_page"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_leave")
        })
            .then(result => {
                if (result.isConfirmed) {
                    close();
                }
            });
    }

    function close() {
        setModalShow(false);
        setOrderData({
            project_name: "",
            amount: "",
            first_name: "",
            last_name: "",
            street_name: "",
            postal_code: "",
            city: "",
            country: "",
            menu_format: "",
            paper_size: "",
            finish: "",
            cover_title: "",
            footer_text: "",
            order_details: ""
        });
        setLogoImage(null);
        setShowLogoImage(null);
    }

    const clickUseMyInfo = () => {
        setUseMyInfo(!useMyInfo);
        if (!useMyInfo === true) {
            // let result = companies.filter(e => e._id === company.value);
            // let countryRes = countries.filter(e => e._id === result[0].address.country);
            // if (countryRes.length > !0) {
            //     dispatch(openSnackBar({ status: "warning", message: t("msg_select_company") }));
            //     return;
            // }
            // setUserData({ ...orderData, street_name: result[0].address.street, postal_code: result[0].address.postalcode, city: result[0].address.city, country: { value: countryRes[0]._id, label: countryRes[0].name[`${globalState.language}`] } })
        } else {
            // setUserData({ ...orderData, street_name: "", postal_code: "", city: "", country: "" })
        }
    }

    return (
        <>
            <div className=" pr-4">
                <Button onClick={() => openModal()} className="bg-sitetx-100">
                    <HiOutlineCube className="mr-2 h-5 w-5" />
                    {t("order_detail")}
                </Button>
            </div>
            <Modal
                show={modalShow}
                size="lg"
                popup={true}
                onClose={() => closeModal()}
            >
                <Modal.Header>
                    {t("order_detail")}
                </Modal.Header>
                <hr />
                <Modal.Body className="overflow-y-auto" style={{ maxHeight: "70vh" }}>
                    <div>
                        <div className="m-2 ml-2 text-sm block">
                            {t("order_project_name")}<span className='text-red-700'>*</span>
                        </div>
                        <TextInput
                            type="text"
                            onChange={e => handleInputChange("project_name", e.target.value)}
                            // placeholder="Producer Name"
                            value={orderData.project_name}
                        />
                    </div>
                    
                    <Tabs.Group
                        className="justify-center pt-4"
                        aria-label="Tabs with underline"
                        // onClick={e => setSelectedTab(e.target.innerText)}
                        style="underline"
                    >
                        <Tabs.Item
                            active={true}
                            title={t("shipping")}
                            className="w-2/5"
                        >
                            <div>
                                <div className="m-2 ml-2 text-sm block">
                                    {t("amount")}
                                </div>
                                <SelectCustomStyle>
                                    <Select
                                        value={orderData.amount}
                                        onChange={value => handleInputChange("amount", value)}
                                        options={amount_options}
                                        isSearchable
                                    />
                                </SelectCustomStyle>
                            </div>

                            <label className="inline-flex relative items-center cursor-pointer m-4">
                                <input type="checkbox" value="" onChange={() => clickUseMyInfo()} className="sr-only peer" checked={useMyInfo} />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t("ship_to_my_address")}</span>
                            </label>
                            
                            {
                                !useMyInfo && 
                                <div>
                                    <div className="grid grid-cols-12 gap-4">
                                        <div className="col-span-6">
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("first_name")}
                                            </div>
                                            <TextInput
                                                type="text"
                                                placeholder={t("first_name")}
                                                required={true}
                                                onChange={e => handleInputChange("first_name", e.target.value)}
                                                value={orderData.first_name}
                                            />
                                        </div>
                                        <div className="col-span-6">
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("last_name")}
                                            </div>
                                            <TextInput
                                                type="text"
                                                placeholder={t("last_name")}
                                                required={true}
                                                onChange={e => handleInputChange("last_name", e.target.value)}
                                                value={orderData.last_name}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div>
                                        <div className="m-2 ml-2 text-sm block">
                                            {t("street_name_number")}
                                        </div>
                                        <TextInput
                                            type="text"
                                            placeholder={t("street_name_number")}
                                            required={true}
                                            onChange={e => handleInputChange("street_name", e.target.value)}
                                            value={orderData.street_name}
                                        />
                                    </div>
                                    <div className="grid grid-cols-12 gap-4">
                                        <div className="col-span-4">
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("postal_code")}
                                            </div>
                                            <TextInput
                                                type="text"
                                                placeholder={t("postal_code")}
                                                required={true}
                                                onChange={e => handleInputChange("postal_code", e.target.value)}
                                                value={orderData.postal_code}
                                            />
                                        </div>
                                        <div className="col-span-8">
                                            <div className="m-2 ml-2 text-sm block">
                                                {t("city")}
                                            </div>
                                            <TextInput
                                                type="text"
                                                placeholder={t("city")}
                                                required={true}
                                                onChange={e => handleInputChange("city", e.target.value)}
                                                value={orderData.city}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="m-2 ml-2 text-sm block">
                                            {t("country")}
                                        </div>
                                        <SelectCustomStyle>
                                            <Select
                                                value={orderData.country}
                                                onChange={value => handleInputChange("country", value)}
                                                options={country_options}
                                                isSearchable
                                            />
                                        </SelectCustomStyle>
                                    </div>
                                </div>
                            }
                        </Tabs.Item>
                        <Tabs.Item
                            // active={selectedTab === "Advanced"}
                            className="w-2/5"
                            title={t("design")}
                        >
                            <div>
                                <div className="m-2 ml-2 text-sm block">
                                    {t("menu_format")}
                                </div>
                                <SelectCustomStyle>
                                    <Select
                                        value={orderData.menu_format}
                                        onChange={value => selectMenuFormat(value)}
                                        options={menu_format_options}
                                        isSearchable
                                    />
                                </SelectCustomStyle>
                            </div>

                            <div>
                                <div className="m-2 ml-2 text-sm block">
                                    {t("paper_size")}
                                </div>
                                <SelectCustomStyle>
                                    <Select
                                        value={orderData.paper_size}
                                        onChange={value => handleInputChange("paper_size", value)}
                                        options={page_format_options}
                                        isSearchable
                                        isDisabled={pageDisable}
                                    />
                                </SelectCustomStyle>
                            </div>

                            <div>
                                <div className="m-2 ml-2 text-sm block">
                                    {t("finish")}
                                </div>
                                <SelectCustomStyle>
                                    <Select
                                        value={orderData.finish}
                                        onChange={value => handleInputChange("finish", value)}
                                        options={finish_options}
                                        isSearchable
                                        isDisabled={finishDisable}
                                    />
                                </SelectCustomStyle>
                            </div>

                            <UploadImage
                                title={t("restaurant_image")}
                                setImage={setLogoImage}
                                showImage={showLogoImage}
                                setShowImage={setShowLogoImage}
                            />

                            <div>
                                <div className="m-2 ml-2 text-sm block">
                                    {t("cover_title")}
                                </div>
                                <TextInput
                                    type="text"
                                    placeholder={t("cover_title")}
                                    required={true}
                                    onChange={e => handleInputChange("cover_title", e.target.value)}
                                    value={orderData.cover_title}
                                />
                            </div>

                            <div>
                                <div className="m-2 ml-2 block">
                                    {t("footer_text")}
                                </div>
                                <Textarea
                                    id="searchproducer"
                                    type="text"
                                    placeholder={t("footer_text")}
                                    rows={4}
                                    value={orderData.footer_text}
                                    onChange={(e) => { handleInputChange("footer_text", e.target.value); setCurrentLengthOfFooter(e.target.value.length) }}
                                />
                                <div className={`mt-2 ml-2 text-sm flex justify-between ${currentLengthOfFooter > 100 ? "text-red-600" : "text-sitetx-100"}`}>
                                    <div>max. 100 {t("characters")}</div>
                                    <div>{currentLengthOfFooter}/100</div>
                                </div>
                            </div>
                            
                            <div>
                                <div className="m-2 ml-2 block">
                                    {t("order_details")}
                                </div>
                                <Textarea
                                    id="searchproducer"
                                    type="text"
                                    placeholder={t("order_details")}
                                    rows={4}
                                    value={orderData.order_details}
                                    onChange={(e) => handleInputChange("order_details", e.target.value)}
                                />
                                {/* <div className={`mt-2 ml-2 text-sm flex justify-between ${currentLengthOfFooter > 100 ? "text-red-600" : "text-sitetx-100"}`}>
                                    <div>max. 100 {t("characters")}</div>
                                    <div>{currentLengthOfFooter}/100</div>
                                </div> */}
                            </div>

                        </Tabs.Item>
                    </Tabs.Group>

                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div className="flex flex-wrap items-center gap-4 m-auto">
                        <div>
                            <Button onClick={() => closeModal()} className="bg-white bg-opacity-0 text-sitetx-100">
                                <HiOutlineTrash className="mr-2 h-5 w-5" />
                                {t("clear_order_detail")}
                            </Button>
                        </div>
                        <div>
                            <Button onClick={() => createProduct()} className="bg-sitebg-300">
                                {t("save_order_detail")}
                                <HiOutlineDocumentAdd className="ml-2 h-6 w-6" />
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default OrderDetail;
